import { useSelector } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { firstErrorMessage } from '@/utils/errors';
import { readStates } from '@/constants/lifecycle';
import { isVisibleDataModel } from '../helper';

const useDataModelsDropdown = ({ dataModel, showHidden }) => useSelector(({
  datasetDataModels: {
    dataModels: { all: { results, readErrors, readStatus } },
  },
}) => {
  const items = results.filter((item) => showHidden || isVisibleDataModel(item));

  return {
    dataModels: items.filter(({ enabled, code }) => enabled || code === dataModel),
    error: firstErrorMessage(readErrors),
    readStatus,
  };
});

const useDatasetDataModelDropdown = ({ category, code }) => useSelector(({ datasetDataModels: { dataModels } }) => {
  const item = findResult(dataModels, category, code) || { dataModelCode: null, ...readStates };

  return {
    dataModel: item.dataModelCode,
    error: firstErrorMessage(item.readErrors),
    readStatus: item.readStatus,
  };
});

export default {
  useDataModelsDropdown,
  useDatasetDataModelDropdown,
};
